import { z, type ZodType } from '@customerio/hydra-validation';
import type { AudienceCredential as UIAPIAudienceCredential } from '@customerio/hydra-ui-api';
import { defineEntity } from '../shared/define-entity';

/**
 * Ad-audience credential (workspace-scoped) — one per connected ad network
 * (`facebook` / `adwords`). Presence of a credential for a network is what the
 * integrations directory reads to mark Google Ads / Facebook Ads as enabled.
 * The wire ships a numeric id; normalize to string per the layer convention.
 */
export type AudienceCredential = Omit<UIAPIAudienceCredential, 'id'> & { id: string };

const AudienceCredentialFromApi = z.looseObject({
  id: z.number().transform(String),
  type: z.string(),
}) as unknown as ZodType<AudienceCredential, unknown>;

/** @public */
export const audienceCredential = defineEntity<AudienceCredential, AudienceCredential, void, undefined, 'workspace'>({
  name: 'audience_credential',
  scope: 'workspace',
  pk: (c) => c.id,
  schema: { read: AudienceCredentialFromApi },
});

export const audienceCredentialKeys = audienceCredential.keys;

export function parseAudienceCredential(raw: UIAPIAudienceCredential): AudienceCredential {
  return audienceCredential.parse(raw);
}
